module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "confirmFeedLider",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("Pedir feedback a lider")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("Seleccione el lider")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "required": "",
      "name": "lideres",
      "id": "lideres"
    },
    model: {
      value: (_vm.miLider),
      callback: function($$v) {
        _vm.miLider = $$v
      },
      expression: "miLider"
    }
  }, _vm._l((_vm.lideres), function(lider) {
    return _c('md-option', {
      key: lider['.key'],
      attrs: {
        "value": lider.email
      }
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": lider.photoURL,
        "alt": "Avatar"
      }
    })]), _vm._v(" \n            " + _vm._s(lider.displayName) + "\n          ")], 1)
  }))], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "md-error"
  }, [_vm._v("Seleccione un lider antes de confirmar")])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onConfirmFeedLider('cancel', 'confirmFeedLider')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onConfirmFeedLider('ok', 'confirmFeedLider')
      }
    }
  }, [_vm._v("Confirmar")])], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "toastLider",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": 4000
    },
    on: {
      "close": function($event) {
        _vm.clearInput()
      }
    }
  }, [_c('span', [_vm._v("El feedback se pidio correctamente a: " + _vm._s(_vm.miLider))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e11378d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackLider.vue
// module id = 380
// module chunks = 1